import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class OrderByPipe implements PipeTransform {

  transform(options: any[], parameter: string): unknown {
   return options?.sort((a, b) => a[parameter]?.localeCompare(b[parameter]));

  }

}
